import { isNullOrUndefOrEmpty } from "@civicscience/chops";

type GetQuestionCompareChartTitleProps = {
  questionText?: string;
  compareQuestionText?: string;
};

export const getQuestionCompareChartTitle = ({
  questionText,
  compareQuestionText,
}: GetQuestionCompareChartTitleProps): string | undefined => {
  return isNullOrUndefOrEmpty(questionText)
    ? undefined
    : `${questionText} <strong>COMPARED WITH</strong> ${compareQuestionText}`;
};
